module.exports = __webpack_public_path__ + "static/media/game(21).e321d575.PNG";